import "./App.css";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import DashboardGuard from "./pages/dashboard/DashboardGuard";
import PrivateRoutes from "./utils/private-routes";
import Login from './pages/login/Login';
//! Astrologer
import Astrologer from "./pages/astrologer";
import AstrologerEnquiry from "./pages/astrologer/astrologer-enquiry";
import AddAstrologer from "./pages/astrologer/add-astrologer";
import ViewAstrologer from "./pages/astrologer/view-astrologer";
import WithdrawalRequest from "./pages/astrologer/withdrawal-request";
import AstrologerManage from "./pages/astrologer-manage";
//! User
import DisplayUser from "./pages/user/DisplayUser";
import NewUsers from "./pages/new-users";
import Utilities from "./pages/utilities";
import AddUser from "./pages/user/AddUser";
//! Sub Admin
import SubAdmin from "./pages/sub-admin/user/SubAdmin";
import AddSubAdmin from "./pages/sub-admin/user/AddSubAdmin";
//! Astro-Mall
import AstroMallCategory from "./pages/astro-mall/category";
import AstroMallAddCategory from "./pages/astro-mall/category/add-category";
import AstroMallProduct from "./pages/astro-mall/product";
import AstroMallAddProduct from "./pages/astro-mall/product/add-product";
import AstroMallOrderHistory from "./pages/astro-mall/order-history";
//! Astro-Puja     
import Puja from "./pages/astro-puja/puja";
import AddPuja from "./pages/astro-puja/puja/add-puja";
import PujaRequest from "./pages/astro-puja/puja-request";
import PujaBooked from "./pages/astro-puja/puja-booked";
import PujaHistory from "./pages/astro-puja/puja-history";
// //! History
// import ChatHistory from "./pages/history/chat-history";
// import ChatSummary from "./pages/history/chat-history/chat-summary";
// import CallHistory from "./pages/history/call-history";
// import VideoCallHistory from "./pages/history/video-call-history";
// import LiveHistory from "./pages/history/live-history";
// import GiftHistory from "./pages/history/gift-history";
// //! Skill 
// import Skill from "./pages/skill";
// import AddSkill from "./pages/skill/add-skill";
// //! Remedies 
// import Remedies from "./pages/remedies";
// import AddRemedies from "./pages/remedies/add-remedies";
// //! Expertise 
// import Expertise from "./pages/expertise";
// import AddExpertiseNew from "./pages/expertise/add-expertise";
// import MainExpertise from "./pages/expertise/main-expertise";
// import AddMainExpertiseNew from "./pages/expertise/main-expertise/add-main-expertise";
//! Service History
import RechargeHistory from "./pages/service-history/recharge-history";
import FastagHistory from "./pages/service-history/fastag-history";
import GasHistory from "./pages/service-history/gas-history";
import DTHHistory from "./pages/service-history/dth-history";
//! Reports & App Errors
import Reports from "./pages/reports";
import AstrologyReports from "./pages/astrology-reports";
import AppErrors from "./pages/app-errors";
//! Language 
import Language from "./pages/language";
import AddLanguage from "./pages/language/add-language";
//! Banner
import Banner from "./pages/banner";
import AddBanner from "./pages/banner/add-banner";
//! Category 
import Category from "./pages/category";
import AddCategory from "./pages/category/add-category";
//! Sub-Category 
import SubCategory from "./pages/sub-category";
import AddSubCategory from "./pages/sub-category/add-sub-category";
//! Yatra
//? Yatra
import DisplayPackage from "./pages/yatra/yatra/DisplayPackage";
import AddPackage from "./pages/yatra/yatra/AddPackage";
//! Sanchar 
//? Podcast
import DisplayPodcast from "./pages/sanchar/podcast/DisplayPodcast";
import AddPodcast from "./pages/sanchar/podcast/AddPodcast";
//? Videoclip
import DisplayVideoclip from "./pages/sanchar/videoclip/DisplayVideoclip";
import AddVideoclip from "./pages/sanchar/videoclip/AddVideoclip";
//? News 
import News from "./pages/sanchar/news";
import AddNews from "./pages/sanchar/news/add-news";
//? Live
import Live from "./pages/sanchar/live";
import AddLive from "./pages/sanchar/live/add-live";
//! SPL Live
import SplLive from "./pages/spl-live";
//! Religious
//? Daily Darshan
import DailyDarshan from "./pages/religious/daily-darshan";
import AddDailyDarshan from "./pages/religious/daily-darshan/add-daily-darshan";
//! E-commerce  
//? Category
import DisplayEcommerceCategory from "./pages/e-commerce/category/DisplayCategory";
import AddEcommerceCategory from "./pages/e-commerce/category/AddCategory";
import DisplayEcommerceSingleCategory from "./pages/e-commerce/category/single-category/DisplaySingleCategory";
//? Sub Category
import DisplayEcommerceSubCategory from "./pages/e-commerce/sub-category/DisplaySubCategory";
import AddEcommerceSubCategory from "./pages/e-commerce/sub-category/AddSubCategory";
//? Product
import DisplayEcommerceProduct from "./pages/e-commerce/product/DisplayProduct";
import AddEcommerceProduct from "./pages/e-commerce/product/AddProduct";
//? Attribute
import DisplayEcommerceAttribute from "./pages/e-commerce/attribute/DisplayAttribute";
import AddEcommerceAttribute from "./pages/e-commerce/attribute/AddAttribute";
//! Transaction 
import DisplayTransaction from "./pages/transaction/DisplayTransaction";
//! Testimonials 
import DisplayTestimonials from "./pages/testimonials/DisplayTestimonials";
import AddTestimonials from "./pages/testimonials/AddTestimonials";
//! Static Page
import TermsAndConditions from "./pages/static-page/terms-and-conditions";
import PrivacyPolicies from "./pages/static-page/privacy-policies";
import AboutUs from "./pages/static-page/about-us";
import RefundPolicy from "./pages/static-page/refund-policy";
import TransactionDetailsById from "./pages/transaction/TransactionDetailsById";
import OperatorImages from "./pages/operatorImages/OperatorImages";
import FlightAdmin from "./pages/flightAdmin/flightAdmin";
import DisplayOperatorImages from "./pages/operator-images/DisplayOperatorImages";
import AddOperatorImages from "./pages/operator-images/AddOperatorImages";
import DisplayFlightImage from "./pages/flight-images/DisplayFlightImage";
import AddFlightImage from "./pages/flight-images/AddFlightImage";
import ElectricityHistory from "./pages/service-history/electricity-history";
import YatraHistory from "./pages/yatra/yatraHistory";
import Consultant from "./pages/consultant";
//! TBO Bookings
import TBOSettings from "./pages/tbo-settings";
//! Milan Sathi
import MilanSathiDashboard from "./pages/milan-sathi/dashboard";
import MilanSathiUsers from "./pages/milan-sathi/users";
import MilanSathiVerifications from "./pages/milan-sathi/verifications";
import MilanSathiPlans from "./pages/milan-sathi/plans";
import MilanSathiTransactions from "./pages/milan-sathi/transactions";
import AllTransactions from "./pages/all-transactions";
import FraudBlocks from "./pages/fraud-blocks";
import MilanSathiUserDetails from "./pages/milan-sathi/user-details";
import NameVerification from "./pages/milan-sathi/name-verification";
import AdminCreateProfile from "./pages/milan-sathi/create-profile";
import FlightBookings from "./pages/tbo-bookings/flight-bookings";
import HotelBookings from "./pages/tbo-bookings/hotel-bookings";
import PostBanaoDashboard from "./pages/post-banao";
import Notifications from "./pages/notifications";
import AppConfig from "./pages/app-config";
import PaymentGateways from "./pages/payment-gateways";
import ComprehensiveDashboard from "./pages/comprehensive-dashboard";
import HomeSections from "./pages/home-sections";


//! Astrologer Admin
import { AstrologerKYC, ConsultationManagement, AstrologerPayouts, AstrologerRatings } from "./pages/astrologer-admin";

//! Rojgar Module
import { ProviderKYC, JobModeration, SeekerManagement, RojgarDashboard, RojgarManagement } from "./pages/rojgar";

//! Marketplace Module
import YatraChildCategories from "./pages/yatra/childCategory/YatraChildCategories";
import { MarketplaceDashboard, VendorManagement, ProductApprovals, OrderManagement, CommissionRules, Settlements, MarketplaceCategories } from "./pages/marketplace";
//! Sanatani Manch Module
import { SanataniDashboard, SanataniUsers, SanataniPosts, SanataniCategories, SanataniEvents, SanataniFlags, ServicePlans, PurchaseHistory, BannedNames, SanataniKutumbMembers } from "./pages/sanatani-manch";
// Grow Module
import GrowCategories from "./pages/grow/GrowCategories";
import GrowServices from "./pages/grow/GrowServices";
import GrowPurchases from "./pages/grow/GrowPurchases";
//! Sanatani Sadan (Hotel)
import SSPartners from "./pages/sanatani-sadan/partners";
import SSProperties from "./pages/sanatani-sadan/properties";
import SSBookings from "./pages/sanatani-sadan/bookings";
import SSAnalytics from "./pages/sanatani-sadan/analytics";
import SSLocations from "./pages/sanatani-sadan/locations";
import VendorAgreements from "./pages/vendor-agreements";
import SanataniCommission from "./pages/sanatani-sadan/SanataniCommission";
import SanataniSettlements from "./pages/sanatani-sadan/SanataniSettlements";
//! Roles & Logs
import RoleManagement from "./pages/roles";
import AddRole from "./pages/roles/add-role";
import ActivityLogs from "./pages/activity-logs";


//! Issue Control Module
import IssueDashboard from "./pages/issue-control/IssueDashboard";
import IssueList from "./pages/issue-control/IssueList";
import CreateIssue from "./pages/issue-control/CreateIssue";
import IssueDetails from "./pages/issue-control/IssueDetails";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoutes />}>
          <Route index element={<DashboardGuard />} />
          <Route path="*" element={<div style={{ color: "#000", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "50vh" }}>Not Found</div>} />
          {/* Astrologer */}
          <Route path="/astrologer" element={<Astrologer />} />
          <Route path="/astrologer-enquiry" element={<AstrologerEnquiry />} />
          <Route path="/astrologer/add-astrologer" element={<AddAstrologer mode="Add" />} />
          <Route path="/astrologer/edit-astrologer" element={<AddAstrologer mode="Edit" />} />
          <Route path="/astrologer/view-astrologer" element={<ViewAstrologer />} />
          <Route path="/withdrawal-request" element={<WithdrawalRequest />} />
          {/* User */}
          <Route path="/astrologer-manage" element={<AstrologerManage />} />
          <Route path="/user" element={<DisplayUser />} />
          <Route path="/new-users" element={<NewUsers />} />
          <Route path="/utilities" element={<Utilities />} />
          <Route path="/add-user" element={<AddUser />} />
          {/* Sub Admin */}
          <Route path="/sub-admin" element={<SubAdmin />} />
          <Route path="/add-sub-admin" element={<AddSubAdmin />} />
          {/* Astro-Mall */}
          <Route path="/astro-mall/category" element={<AstroMallCategory />} />
          <Route path="/astro-mall/category/add-category" element={<AstroMallAddCategory />} />
          <Route path="/astro-mall/product" element={<AstroMallProduct />} />
          <Route path="/astro-mall/product/add-product" element={<AstroMallAddProduct mode={'Add'} />} />
          <Route path="/astro-mall/product/edit-product" element={<AstroMallAddProduct mode={'Edit'} />} />
          <Route path="/astro-mall/order-history" element={<AstroMallOrderHistory />} />
          {/* Astro-Puja */}
          <Route path="/astro-puja/puja" element={<Puja />} />
          <Route path="/astro-puja/puja/add-puja" element={<AddPuja />} />
          <Route path="/astro-puja/puja-request" element={<PujaRequest />} />
          <Route path="/astro-puja/puja-booked" element={<PujaBooked />} />
          <Route path="/astro-puja/puja-history" element={<PujaHistory />} />
          {/* Language */}
          <Route path="/language" element={<Language />} />
          <Route path="/language/add-language" element={<AddLanguage mode="Add" />} />
          <Route path="/language/edit-language" element={<AddLanguage mode="Edit" />} />
          {/* Banner */}
          <Route path="/banner" element={<Banner />} />
          <Route path="/banner/add-banner" element={<AddBanner mode={'Add'} />} />
          <Route path="/banner/edit-banner" element={<AddBanner mode={'Edit'} />} />
          {/* Category */}
          <Route path="/category" element={<Category />} />
          <Route path="/category/add-category" element={<AddCategory mode={'Add'} />} />
          <Route path="/category/edit-category" element={<AddCategory mode={'Edit'} />} />
          {/* Sub-Category */}
          <Route path="/sub-category" element={<SubCategory />} />
          <Route path="/sub-category/add-sub-category" element={<AddSubCategory mode={'Add'} />} />
          <Route path="/sub-category/edit-sub-category" element={<AddSubCategory mode={'Edit'} />} />
          {/* Yatra */}
          <Route path="/yatra" element={<DisplayPackage />} />
          <Route path="/add-yatra" element={<AddPackage />} />
          <Route path="/yatraHistory" element={<YatraHistory />} />
          <Route path="/yatra-child-categories" element={<YatraChildCategories />} />
          {/* Podcast */}
          <Route path="/podcast" element={<DisplayPodcast />} />
          <Route path="/add-podcast" element={<AddPodcast />} />
          {/* Videoclip */}
          <Route path="/video-clip" element={<DisplayVideoclip />} />
          <Route path="/add-video-clip" element={<AddVideoclip />} />
          {/* News */}
          <Route path="/news" element={<News />} />
          <Route path="/news/add-news" element={<AddNews mode={'Add'} />} />
          <Route path="/news/edit-news" element={<AddNews mode={'Edit'} />} />
          <Route path="/live" element={<Live />} />
          <Route path="/live/add-live" element={<AddLive mode={'Add'} />} />
          <Route path="/live/edit-live" element={<AddLive mode={'Edit'} />} />
          {/* SPL Live */}
          <Route path="/spl-live" element={<SplLive />} />
          {/* Religious */}
          {/* Daily Darshan */}
          <Route path="/religious/daily-darshan" element={<DailyDarshan />} />
          <Route path="/religious/daily-darshan/add-daily-darshan" element={<AddDailyDarshan mode={'Add'} />} />
          <Route path="/religious/daily-darshan/edit-daily-darshan" element={<AddDailyDarshan mode={'Edit'} />} />
          {/* Ecommerce Category */}
          <Route path="/e-commerce/category" element={<DisplayEcommerceCategory />} />
          <Route path="/e-commerce/add-category" element={<AddEcommerceCategory />} />
          <Route path="/e-commerce/category/:id" element={<DisplayEcommerceSingleCategory />} />
          {/* Ecommerce Sub Category */}
          <Route path="/e-commerce/sub-category" element={<DisplayEcommerceSubCategory />} />
          <Route path="/e-commerce/add-sub-category" element={<AddEcommerceSubCategory />} />
          {/* Ecommerce Product */}
          <Route path="/e-commerce/product" element={<DisplayEcommerceProduct />} />
          <Route path="/e-commerce/add-product" element={<AddEcommerceProduct />} />
          {/* Ecommerce Attribute */}
          <Route path="/e-commerce/attribute" element={<DisplayEcommerceAttribute />} />
          <Route path="/e-commerce/add-attribute" element={<AddEcommerceAttribute />} />
          {/* Transaction */}
          <Route path="/transaction/*" element={<DisplayTransaction />} />
          <Route path="/transaction/details" element={<TransactionDetailsById />} />
          <Route path="/all_consultant_requests" element={<Consultant />} />
          {/* Operator Images */}
          <Route path="/operator-images" element={<DisplayOperatorImages />} />
          <Route path="/add-operator-images" element={<AddOperatorImages mode={'Add'} />} />
          <Route path="/edit-operator-images" element={<AddOperatorImages mode={'Edit'} />} />
          <Route path="/flight-images" element={<DisplayFlightImage />} />
          <Route path="/add-flight-images" element={<AddFlightImage mode={'Add'} />} />
          <Route path="/edit-flight-images" element={<AddFlightImage mode={'Edit'} />} />
          <Route path="/operator-image" element={<OperatorImages />} />
          <Route path="/flight-image" element={<FlightAdmin />} />
          {/* Testimonials */}
          <Route path="/testimonials" element={<DisplayTestimonials />} />
          <Route path="/add-testimonials" element={<AddTestimonials />} />
          {/* Static Page */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policies" element={<PrivacyPolicies />} />
          <Route path="/refund-policies" element={<RefundPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
          {/* RechargeHistory */}
          <Route path="/rechargeHistory/recharge-history" element={<RechargeHistory />} />
          <Route path="/rechargeHistory/fastag-history" element={<FastagHistory />} />
          <Route path="/rechargeHistory/gas-history" element={<GasHistory />} />
          <Route path="/rechargeHistory/dth-history" element={<DTHHistory />} />
          <Route path="/rechargeHistory/electricity-history" element={<ElectricityHistory />} />
          {/* Reports & App Errors */}
          <Route path="/reports" element={<Reports />} />
          <Route path="/astrology-reports" element={<AstrologyReports />} />
          <Route path="/app-errors" element={<AppErrors />} />
          {/* TBO Bookings */}
          <Route path="/tbo/settings" element={<TBOSettings />} />
          <Route path="/tbo/flight-bookings" element={<FlightBookings />} />
          <Route path="/tbo/hotel-bookings" element={<HotelBookings />} />
          <Route path="/post-banao" element={<PostBanaoDashboard />} />
          {/* Milan Sathi */}
          <Route path="/milan-sathi" element={<MilanSathiDashboard />} />
          <Route path="/milan-sathi/users" element={<MilanSathiUsers />} />
          <Route path="/milan-sathi/verifications" element={<MilanSathiVerifications />} />
          <Route path="/milan-sathi/plans" element={<MilanSathiPlans />} />
          <Route path="/milan-sathi/transactions" element={<MilanSathiTransactions />} />
          <Route path="/all-transactions" element={<AllTransactions />} />
          <Route path="/fraud-blocks" element={<FraudBlocks />} />
          <Route path="/milan-sathi/user-details/:userId" element={<MilanSathiUserDetails />} />
          <Route path="/milan-sathi/name-verification" element={<NameVerification />} />
          <Route path="/milan-sathi/create-profile" element={<AdminCreateProfile />} />
          {/* Notifications */}
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/app-config" element={<AppConfig />} />
          <Route path="/payment-gateways" element={<PaymentGateways />} />
          {/* Comprehensive Dashboard */}
          <Route path="/comprehensive-dashboard" element={<ComprehensiveDashboard />} />
          {/* Astrologer Admin */}
          <Route path="/astrologer-admin/kyc" element={<AstrologerKYC />} />
          <Route path="/astrologer-admin/consultations" element={<ConsultationManagement />} />
          <Route path="/astrologer-admin/payouts" element={<AstrologerPayouts />} />
          <Route path="/astrologer-admin/ratings" element={<AstrologerRatings />} />
          
          {/* Rojgar Module */}
          <Route path="/rojgar/dashboard" element={<RojgarDashboard />} />
          <Route path="/rojgar/seekers" element={<SeekerManagement />} />
          <Route path="/rojgar/provider-kyc" element={<ProviderKYC />} />
          <Route path="/rojgar/job-moderation" element={<JobModeration />} />
          <Route path="/rojgar/management" element={<RojgarManagement />} />
          
          {/* Marketplace Module */}
          <Route path="/marketplace/dashboard" element={<MarketplaceDashboard />} />
          <Route path="/marketplace/vendors" element={<VendorManagement />} />
          <Route path="/vendor-management/all" element={<VendorManagement />} />
          <Route path="/vendor-management/pending" element={<VendorManagement initialTab="pending" />} />
          <Route path="/vendor-management/sanatani-commission" element={<SanataniCommission />} />
          <Route path="/vendor-management/sanatani-settlements" element={<SanataniSettlements />} />
          <Route path="/marketplace/products" element={<ProductApprovals />} />
          <Route path="/marketplace/orders" element={<OrderManagement />} />
          <Route path="/marketplace/commission" element={<CommissionRules />} />
          <Route path="/marketplace/settlements" element={<Settlements />} />
          <Route path="/marketplace/categories" element={<MarketplaceCategories />} />
          
          {/* Sanatani Manch Routes */}
          <Route path="/sanatani-manch/dashboard" element={<SanataniDashboard />} />
          <Route path="/sanatani-manch/users" element={<SanataniUsers />} />
          <Route path="/sanatani-manch/kutumb-members" element={<SanataniKutumbMembers />} />
          <Route path="/sanatani-manch/posts" element={<SanataniPosts />} />
          <Route path="/sanatani-manch/categories" element={<SanataniCategories />} />
          <Route path="/sanatani-manch/events" element={<SanataniEvents />} />
          <Route path="/sanatani-manch/flags" element={<SanataniFlags />} />
          <Route path="/sanatani-manch/service-plans" element={<ServicePlans />} />
          <Route path="/sanatani-manch/purchases" element={<PurchaseHistory />} />
          <Route path="/sanatani-manch/banned-names" element={<BannedNames />} />

          {/* Sanatani Sadan (Hotel) */}
          <Route path="/sanatani-sadan/partners" element={<SSPartners />} />
          <Route path="/sanatani-sadan/properties" element={<SSProperties />} />
          <Route path="/sanatani-sadan/bookings" element={<SSBookings />} />
          <Route path="/sanatani-sadan/analytics" element={<SSAnalytics />} />
          <Route path="/sanatani-sadan/locations" element={<SSLocations />} />
          <Route path="/vendor-agreements" element={<VendorAgreements />} />

          
          {/* Grow Module */}
          <Route path="/grow/categories" element={<GrowCategories />} />
          <Route path="/grow/services" element={<GrowServices />} />
          <Route path="/grow/purchases" element={<GrowPurchases />} />

          {/* Roles & Logs */}
          <Route path="/roles" element={<RoleManagement />} />
          <Route path="/roles/add-role" element={<AddRole />} />
          <Route path="/roles/edit-role" element={<AddRole />} />
          <Route path="/activity-logs" element={<ActivityLogs />} />

          {/* Issue Control */}
          <Route path="/home-sections" element={<HomeSections />} />
          <Route path="/issues/dashboard" element={<IssueDashboard />} />
          <Route path="/issues/create" element={<CreateIssue />} />
          <Route path="/issues/:id" element={<IssueDetails />} />
          <Route path="/issues" element={<IssueList />} />


        </Route>
      </Routes>
    </Router>
  );
}
export default App;
